import type { CopilotMode } from '@/features/dashboard/experiences/use-copilot-mode';

export interface CopilotStarter {
  id: string;
  externalId: string;
  title: string;
  description: string;
  coverImage: string;
  group: string;
  prompt: string;
  attachments: string[];
  isPublished: boolean;
  order: number;
  copilotMode: CopilotMode;
}

export interface StartersResponse {
  starters: CopilotStarter[];
  count: number;
}

export const emptyCopilotStarter = (): CopilotStarter => ({
  id: ``,
  externalId: ``,
  title: ``,
  description: ``,
  coverImage: ``,
  group: ``,
  prompt: ``,
  attachments: [],
  isPublished: false,
  order: 0,
  copilotMode: `Build`,
});

export const shouldFallbackToSingleText = (
  title?: string,
  description?: string,
) => {
  const trimmedTitle = title?.trim?.() || ``;
  const trimmedDescription = description?.trim?.() || ``;

  if (!trimmedTitle || !trimmedDescription) {
    return true;
  }

  return trimmedTitle.toLowerCase() === trimmedDescription.toLowerCase();
};

export const getFallbackStarterText = (
  title?: string,
  description?: string,
) => {
  const trimmedTitle = title?.trim?.() || ``;
  const trimmedDescription = description?.trim?.() || ``;
  return trimmedTitle || trimmedDescription;
};
